import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import { VpButton, VpIcon, VpHookFormWrapper, VpHookFormInput } from '../..';

import {
  FullWidthStack,
  ModalContainer,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SubTitle,
  Title
} from './styles';
import VpHookPluginTypeDisplay from './VpHookPluginTypeDisplay';
import { useMediaTableContext } from '../../../hooks';

export const VpCreatePluginDialog = withRouter(
  ({
    _createNewPlugin,
    _hidePluginChoiceModal,
    createdPluginId,
    history,
    includeAttachments,
    shouldShowPluginChoiceModal,
    userName
  }) => {
    const [isCreated, setIsCreated] = useState(false);

    useEffect(() => {
      // If createdPluginId changes, redirect to
      // plugin editing page
      if (createdPluginId !== null && isCreated) {
        history.push(`/v2/plugins/${createdPluginId}`, { from: 'MEDIA_PAGE_PLUGIN_CREATE' });
      }
    }, [createdPluginId]);

    const { getSelectedContent, getSelectedVideoIds } = useMediaTableContext();

    const onSubmit = (formData) => {
      const payload = {
        name: formData.pluginName,
        type: formData.pluginChoice,
        showVideoPeelLogo: true,
        sortOrder: 'OLDEST'
      };
      payload[includeAttachments ? 'pluginContent' : 'content'] = includeAttachments
        ? getSelectedContent()
        : getSelectedVideoIds();

      _createNewPlugin(payload);
      _hidePluginChoiceModal();
      setIsCreated(true);
    };

    return (
      <Modal open={shouldShowPluginChoiceModal} onClose={_hidePluginChoiceModal}>
        <VpHookFormWrapper onSubmit={onSubmit}>
          <ModalContainer>
            <ModalHeader>
              <Typography variant="darkBold14">Create Plugin</Typography>
              <IconButton edge="end" onClick={_hidePluginChoiceModal} fontSize="large">
                <VpIcon icon="X" />
              </IconButton>
            </ModalHeader>
            <ModalBody>
              <FullWidthStack direction="column" spacing={7}>
                <FullWidthStack direction="column" alignItems="center">
                  <Title variant="h3">Get Started</Title>
                  <SubTitle variant="dialogBody2">
                    Create a layout and name for your plugin to use on your website, online store,
                    and more!
                  </SubTitle>
                </FullWidthStack>
                <VpHookFormInput
                  smallLabel
                  label="PLUGIN NAME"
                  disableHelperText
                  includeDisplayInput
                  required
                  name="pluginName"
                  defaultValue={`${userName ? `${userName}'s` : 'My'} Plugin`}
                />
                <VpHookPluginTypeDisplay />
              </FullWidthStack>
            </ModalBody>
            <ModalFooter>
              <FullWidthStack direction="row" justifyContent="space-between">
                <VpButton
                  variant="contained"
                  name="cancelPluginChoice"
                  color="neutral"
                  onClick={(e) => {
                    e.preventDefault();
                    _hidePluginChoiceModal();
                  }}
                >
                  Cancel
                </VpButton>
                <VpButton variant="contained" type="submit" name="choosePluginType">
                  Create New Plugin
                </VpButton>
              </FullWidthStack>
            </ModalFooter>
          </ModalContainer>
        </VpHookFormWrapper>
      </Modal>
    );
  }
);

VpCreatePluginDialog.propTypes = {
  _createNewPlugin: PropTypes.func,
  _hidePluginChoiceModal: PropTypes.func,
  createdPluginId: PropTypes.string,
  shouldShowPluginChoiceModal: PropTypes.bool,
  userName: PropTypes.string
};

export default VpCreatePluginDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpCreatePluginDialog/VpCreatePluginDialog.jsx